import React from 'react';
import PropTypes from 'prop-types';
import * as dateFns from 'date-fns';

import dateRangeFormatter from '../../utils/dateRangeFormatter';

export default function LocalizedDateRange(props) {
  const { dates } = props;
  const { startDate, endDate } = dates;

  if (!startDate || !endDate) {
    return "";
  }

  const formattedDateRange = dateRangeFormatter(dates) 

  return (
    <div>
      <span
        className="js-localized-datetime"
        notranslate="true"
        data-behavior="localized-datetime"
        data-format-type='date'
        data-formatted-date-range={formattedDateRange}
        data-timestamp-from={startDate.toString()}
        data-timestamp-to={endDate.toString()}
      >
        {formattedDateRange}
      </span>
      {' '}
      {startDate.toLocaleTimeString('en', {timeZoneName:'short'}).split(' ')[2]} ({dateFns.format(startDate, 'zzzz')})
    </div>
  );
}

LocalizedDateRange.defaultProps = {
  dates: {}
};

LocalizedDateRange.propTypes = {
  dates: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date)
  })
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/toolkit/localized_date_range.jsx